/**
 * @voltxampere/ui — DIP switch 4-position variant (Sprint 44-3, placeholder)
 *
 * PLACEHOLDER. 4-position DIP-housed SPST switch bank — ngspice
 * `switch` × 4 paralel olarak modellenir; şu anki implementasyon
 * tek `switch` ile single-channel davranış gösterir. 4-channel
 * ayrı kontrol Sprint 47+ multi-channel switch composition ile.
 *
 * Reference: Generic 4-position DIP switch (e.g. CTS 206-4, APEM
 * NDP-04). 25 mA @ 24 V DC, slide actuator. PCB konfigürasyon,
 * I2C address ayarı, mod seçim register.
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const switchDip4 = {
    id: "switch-dip-4",
    nameTr: "DIP Switch 4-pos (placeholder, single channel)",
    nameEn: "DIP Switch 4-pos (placeholder, single channel)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "SW",
    defaultValue: "DIP-4",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=switch-dip-4.js.map